import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tippy";
import { uuid } from "uuidv4";
import { addRow, startEditElement } from "../../../../actions/elementListAction";
import { cssStyle } from "../../../../models/cssStyleModel";
import { Element } from "../../../../models/elementModel";
import { TableRowModel } from "../../../../models/tableRowModel";
import chamalCasingCss from "../../common/commonPropertyUtil/chamalCasingCss";
import TableRowItemProperties from "./rowItemProperties";

export interface TableRowListPropertiesProps {
  element: Element;
}

const TableRowListProperties: FC<TableRowListPropertiesProps> = ({
  element,
}) => {
  const [lastRowDefault, setLastRowDefault] = useState(
    element.properties.rows[element.properties.rows.length - 1]
  );
  const dispatch = useDispatch();
  const addARow = async (lastRow: TableRowModel, rowIndex: number) => {
    dispatch(
      addRow(element, lastRow ? lastRow : lastRowDefault, rowIndex ? rowIndex: 0, false)
    );
  };

  const addNewCssStyle = () => {
    let newCssStyle: cssStyle = {
      id: uuid(),
      style: "",
      retrivedStyle: "",
      value: "",
    };
    const newElement = produce(element, (draft) => {
      draft.properties.tbodyCssStyles.push(newCssStyle);
    });
    dispatch(startEditElement(newElement));
  };

  const removeCssStyle = (index: number) => {
    const newElement = produce(element, (draft) => {
      draft.properties.tbodyCssStyles.splice(index, 1);
    });
    dispatch(startEditElement(newElement));
  };
  return (
    <div className="card border-0">
      <div className="" id="tableRows">
        <h5 className="mb-0">
          <button
            className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
            data-toggle="collapse"
            data-target="#Table-row-content"
            aria-expanded="false"
            aria-controls="Table-row-content"
          >
            <div className="row justify-content-end">
              <div className="col-sm-8"> Rows</div>
              <div className="col-sm-2">
                <Tooltip title="Add a New Row To Table">
                  <i
                    className="fa fa-plus"
                    aria-hidden="true"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      addARow(
                        element.properties.rows[
                          element.properties.rows.length - 1
                        ],
                        element.properties.rows.length - 1
                      );
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </button>
        </h5>
      </div>
      <div
        id="Table-row-content"
        className="collapse"
        aria-labelledby="tableRows"
      >
        <div className="card-body theam-card p-0">
          {element.properties.rows.map((row: TableRowModel, i: number) => {
            return (
              <TableRowItemProperties
                element={element}
                rowIndex={i}
                row={row}
              />
            );
          })}
          <br />
        <h6>Advance Style Properties</h6>
        <div className="form-group col-12 p-2 mb-0">
        <button
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={addNewCssStyle}
        >
          <i className="fa fa-plus"></i>
        </button>
          </div>
      {element.properties.tbodyCssStyles.map((_style: cssStyle, i: number) => {
        return (
          <div key={i} className="pb-1">
            <div className="form-group row">
              <div className="col-sm-10"></div>
              <div className="col-sm-2">
                <button
                  type="button"
                  className="btn btn-dark btn-sm font-size-12"
                  onClick={(e) => removeCssStyle(i)}
                >
                  <i className="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-5 pr-0">
                <input
                  type="text"
                  className="form-control theam-textbox"
                  id={`style${i}`}
                  value={_style.style}
                  placeholder="Css Property"
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.properties.tbodyCssStyles[i].style = e.target.value;
                      draft.properties.tbodyCssStyles[i].retrivedStyle =
                        chamalCasingCss(e.target.value);
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
              <div className="col-sm-1 noPadding">:</div>
              <div className="col-sm-6 pl-0">
                <input
                  type="text"
                  className="form-control theam-textbox"
                  id={`value${i}`}
                  value={_style.value}
                  placeholder="Enter Value"
                  onChange={(e) => {
                    const newElement = produce(element, (draft) => {
                      draft.properties.tbodyCssStyles[i].value = e.target.value;
                    });
                    dispatch(startEditElement(newElement));
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
        </div>
      </div>
    </div>
  );
};

export default TableRowListProperties;
